import { Component } from '@angular/core';
import { MigrationsCucmHuntListsContext } from './services/cisco/migrations-cucm-hunt-lists.context';
import { MigrationsCucmHuntListsPollingContext } from './services/cisco/migrations-cucm-hunt-lists-polling.context';
import { MigrationsCucmNumberReportPollingContext } from './services/cisco/migrations-cucm-number-report-polling.context';
import { MigrationsCucmNumberReportContext } from './services/cisco/migrations-cucm-number-report.context';
import { MigrationsCucAutoAttendantsContext } from './services/cisco/migrations-cuc-auto-attendants.context';
import { MigrationsCucAutoAttendantsPollingContext } from './services/cisco/migrations-cuc-auto-attendants-polling.context';
import { MigrationsAssessmentsContext } from './services/migrations-assessments.context';
import { MigrationsAssessmentsPollingService } from './services/migrations-assessments-polling.service';

@Component({
  selector: 'ziro-migrations',
  templateUrl: 'migrations.component.html',
  styleUrls: ['migrations.component.scss'],
  providers: [
    MigrationsAssessmentsContext,
    MigrationsAssessmentsPollingService,
    MigrationsCucmHuntListsContext,
    MigrationsCucmHuntListsPollingContext,
    MigrationsCucmNumberReportPollingContext,
    MigrationsCucmNumberReportContext,
    MigrationsCucAutoAttendantsContext,
    MigrationsCucAutoAttendantsPollingContext,
  ],
  standalone: false,
})
export class MigrationsComponent {}
